import { render, staticRenderFns } from "./ResetPasswordConfirmationForm.vue?vue&type=template&id=33099057&"
import script from "./ResetPasswordConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports